import * as index_es from '../node_modules/prosemirror-state/dist/index.es.js';
import { getAugmentedNamespace } from './_commonjsHelpers.js';

var prosemirrorState = /*@__PURE__*/getAugmentedNamespace(index_es);

export default prosemirrorState;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@spartez/vue-atlaskit/dist/_virtual/index.es.js_commonjs-proxy
// module id = UIjY
// module chunks = 1